import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '~/components/ui/Button';
import { requestUpgrade } from '~/lib/.client/api/organizations';
import type { OrganizationData, OrganizationMembership } from '~/types/organization';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const RequestUpgradeButton = ({
  member,
  organization,
}: {
  member: OrganizationMembership;
  organization: OrganizationData;
}) => {
  const [disabled, setDisabled] = useState(false);
  const UPGRADE_REQUEST_KEY = `${organization.slug}-upgrade-requested:${member.id}`;

  useEffect(() => {
    const stored = localStorage.getItem(UPGRADE_REQUEST_KEY);

    if (stored) {
      const timestamp = Number(stored);
      const expired = Date.now() - timestamp > ONE_DAY_MS;

      if (expired) {
        localStorage.removeItem(UPGRADE_REQUEST_KEY);
      } else {
        setDisabled(true);
      }
    }
  }, []);

  const handleRequestUpgrade = () => {
    setDisabled(true);
    requestUpgrade({
      organization,
      member: {
        id: member.id,
        username: member.user.username,
        email: member.user.email,
      },
    })
      .then(() => {
        localStorage.setItem(UPGRADE_REQUEST_KEY, String(Date.now()));
      })
      .catch((error) => {
        setDisabled(false);

        if (error instanceof Error && error.message) {
          toast.error(error.message);
        }
      });
  };

  return (
    <Button variant="link-color" color="success" onClick={handleRequestUpgrade} disabled={disabled}>
      Request an upgrade
    </Button>
  );
};
